"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "CatalogModel", {
  enumerable: true,
  get: function get() {
    return _model.default;
  }
});
_Object$defineProperty(exports, "CatalogType", {
  enumerable: true,
  get: function get() {
    return _type.default;
  }
});
exports.default = void 0;
var _reducer = _interopRequireDefault(require("./reducer"));
var _actions = _interopRequireDefault(require("./actions"));
var _model = _interopRequireDefault(require("./model"));
var _type = _interopRequireDefault(require("./type"));
function cov_85nb2za5k() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/index.js";
  var hash = "c5bc375432e8883d02d2f4870559dcf09a390c46";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c5bc375432e8883d02d2f4870559dcf09a390c46"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_85nb2za5k = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_85nb2za5k();
var _default = exports.default = {
  reducer: _reducer.default,
  actions: _actions.default
};